import { useTran } from "@/hooks";
import { Info } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

const UnsavedChangesDialog = ({ open, onConfirm, handleClear, onCancel }) => {
  const { t } = useTran();

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onCancel()}>
      <DialogContent
        showCloseButton={false}
        className="flex w-[calc(100vw-1rem)] max-w-[calc(100vw-2rem)] max-h-[calc(100vh-2rem)] flex-col overflow-hidden border border-border bg-card p-5 sm:w-full sm:p-4 sm:rounded-radius sm:max-w-md"
      >
        <div className="flex items-start justify-between gap-3 border-b border-border pb-3 sm:gap-4">
          <DialogHeader className="min-w-0 flex-1 gap-2 text-left">
            <div className="flex min-w-0 items-start gap-3">
              <span className="mt-0.5 inline-flex h-9 w-9 items-center justify-center rounded-full bg-primary/10 text-primary">
                <Info className="h-5 w-5" />
              </span>
              <div className="min-w-0 space-y-1">
                <DialogTitle className="text-xl font-semibold leading-tight text-destructive">
                  {t("Unsaved Changes")}
                </DialogTitle>
                <DialogDescription className="text-sm leading-snug text-muted-foreground">
                  {t("Leaving now will discard your latest edits.")}
                </DialogDescription>
              </div>
            </div>
          </DialogHeader>
        </div>
        <div className="min-h-0 flex-1 flex flex-col overflow-y-auto !px-0 !py-3 sm:!py-4">
          <p className="text-sm text-muted-foreground">
            {t(
              "You have unsaved changes. Are you sure you want to leave without saving? Any unsaved changes will be lost.",
            )}
          </p>
        </div>
        <div>
          <div className="mb-3 h-px bg-border sm:mb-4" />
          <DialogFooter>
            <Button variant="outline" onClick={onCancel}>
              {t("Cancel")}
            </Button>
            <Button
              variant="destructive"
              onClick={() => {
                onConfirm();
                handleClear();
              }}
            >
              {t("Discard Changes")}
            </Button>
          </DialogFooter>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default UnsavedChangesDialog;
